module.exports = __webpack_public_path__ + "img/Email.2ca6c1d0.svg";